import React from 'react';
import {
    Typography,
    Box,
    Paper
} from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
        [theme.breakpoints.only('xs')]: {
            flexDirection: 'column'
        },
    },
    headerWidth: {
        width: '80%',
        [theme.breakpoints.only('xs')]: {
            width: '100%',
        },
    },
    count: {
        marginLeft: 30,
        fontSize: '14px',
        fontWeight: 900,
        color: '#353434',
        marginRight: 10
    },
    flex: {
        [theme.breakpoints.only('xs')]: {
            flex: 2
        },
    },
    paper: {
        padding: '1px',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        borderRadius: '5px',
        marginRight: 'auto',
        backgroundColor: '#a3a3a3',
        margin: '8px 0px 0px 0px',
        [theme.breakpoints.only('xs')]: {
            padding: '6px',
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        },
    }
}));
const WaitListCount = (props) => {
    const classes = useStyles();
    return (
        <> {
            (props.pendingWaitList > 0 || props.approvedWaitList > 0) &&
            <>
                <Box
                >
                    <Paper
                        elevation={3}
                        className={classes.paper}>
                        <Box>
                            <Typography variant='caption' sx={{
                                color: '#353434',// '#FFFFFF',
                            }}>
                                Additional Rooms for Purchase</Typography>
                        </Box>
                        <Box className={classes.container}>
                            <Box className={classes.headerWidth}>
                                <Typography
                                    sx={{
                                        fontWeight: 700,
                                        fontSize: '20px',
                                        lineHeight: '23.44px',
                                        color: '#353434',// '#FFFFFF',
                                    }}>
                                    Waitlist Request :
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'row',
                                    //justifyContent: 'space-between',
                                    m: '5px',
                                    width: '100%',
                                }}>
                                <Box className={classes.flex}>
                                    <Typography component={'span'}
                                        sx={{
                                            fontWeight: 400,
                                            fontSize: '15px',
                                            color: '#353434',// '#FFFFFF',
                                            lineHeight: '25px',
                                        }}>
                                        Pending Requests :
                                    </Typography>

                                </Box>
                                <Box>
                                    <Typography component={'span'}>
                                        <span className={classes.count}>
                                            {props.pendingWaitList}
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>

                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'row',
                                    //justifyContent: 'space-between',
                                    width: '100%',
                                }}>
                                <Box className={classes.flex}>
                                    <Typography component={'span'}
                                        sx={{
                                            fontWeight: 400,
                                            fontSize: '15px',
                                            color: '#353434',// '#FFFFFF',
                                            lineHeight: '25px',
                                        }}>
                                        Approved Requests :
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography component={'span'}>
                                        <span className={classes.count}>
                                            {props.approvedWaitList}
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>

                        </Box>
                    </Paper>
                </Box>
                <Box>
                    <Typography color='secondary' variant='caption'> This hotel room request has been put on the waiting list. Please note these requests are subject to availability and are not to be considered confirmed unless the NBA approves this request.
                    </Typography>
                </Box>
            </>
        }
        </>
    )
}

export default WaitListCount;